module.exports = __webpack_public_path__ + "static/media/google-link.e56054e4.svg";